import { render, staticRenderFns } from "./ItemEdit_Variants_List.vue?vue&type=template&id=2f493b89&"
import script from "./ItemEdit_Variants_List.vue?vue&type=script&lang=js&"
export * from "./ItemEdit_Variants_List.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports